import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { setCurrentForm, updateFormDetails } from "../../redux/actions/forms";
import { useLazyQuery, useMutation } from "@apollo/client";
import { UPDATE_FORM_MUTATION } from "../../GraphQl/Mutations";
import { FaSpinner, FaTrash } from "react-icons/fa";
import {
  IoSettingsOutline,
  IoCopyOutline,
  IoLogoWhatsapp,
} from "react-icons/io5";
import { AiOutlineEye } from "react-icons/ai";
import { HiShare, HiOutlineDownload } from "react-icons/hi";
import { roles } from "../../constants/Roles";
import { EncodeURL, darkenColor, getContrastColor } from "../../functions";
import {
  availableColors,
  availableFonts,
  availableGradients,
} from "../../constants/styles";
import Loader from "../../components/Loader";
import {
  Button,
  Divider,
  message,
  Select,
  Input,
  Popover,
  Skeleton,
} from "antd";
import { GET_FORM_BY_ID, GET_FORM_RESPONSE_COUNT } from "../../GraphQl/Queries";
import QRCode from "qrcode.react";
import { memo } from "react";
import { IoMdShareAlt } from "react-icons/io";

const SingleForm = () => {
  const [formDetails, setFormDetails] = useState({
    formTitle: "",
    description: "",
  });
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [msg, setMessage] = useState(null);

  const { TextArea } = Input;
  const [settingsOpen, setSettingsOpen] = useState(false);
  const state = useSelector((state) => state.allForms);
  const [formFile, setFormFile] = useState(null);
  const [formTheme, setFormTheme] = useState({
    color: state?.currentForm?.formMetadata?.theme?.color || "#fff",
    font:
      state?.currentForm?.formMetadata?.theme?.font || availableFonts[1].value,
    image: state?.currentForm?.formMetadata?.theme?.image,
  });
  const [messageApi, contextHolder] = message.useMessage();

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };
  const previewFile = () => {
    var file = formFile;
    var reader = new FileReader();

    reader.onloadend = (e) => {
      let binaryString = e.target.result;

      setFormTheme({
        ...formTheme,
        image: reader.result,
      });

      // setUserDetails({ ...userDetails, image: btoa(binaryString) });
      // preview.src = `data:image;base64,${userDetails?.image}`;
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [updateForm, { loading, data, error }] = useMutation(
    UPDATE_FORM_MUTATION,
    {
      variables: {
        updateFormId: state?.currentForm?._id,
        updateFormDataInput: {
          adminId: state?.currentForm?.adminDetail?._id,
          description: state?.currentForm?.description,
          formStatus: state?.currentForm?.formStatus,
          formTitle: state?.currentForm?.formTitle,
          formType: state?.currentForm?.formType,
          formMetadata: {
            visibility: state?.currentForm?.formMetadata?.visibility,
            theme: {
              image: state?.currentForm?.formMetadata?.theme?.image,
              font: state?.currentForm?.formMetadata?.theme?.font,
              color: state?.currentForm?.formMetadata?.theme?.color,
            },
          },
          questions: state?.currentForm?.questions.map((question) => {
            return {
              id: question?.id,
              questionTitle: question?.questionTitle,
              questionType: question?.questionType,
              questionMetadata: {
                max: question?.questionMetadata?.max,
                min: question?.questionMetadata?.min,
                choices: question?.questionMetadata?.choices,
              },
              required: question?.required,
            };
          }),
        },
      },
      onCompleted: (data) => {
        success("Form saved successfully! ");
      },
      onError: (error) => {
        err("Couldn't save form ");
      },
    }
  );

  const [getFormById, formById] = useLazyQuery(GET_FORM_BY_ID, {
    variables: {
      getFormByIdAId: params?.id,
    },
    onCompleted: (data) => {
      console.log("CURRENT FORM IS", data);
      setFormDetails({
        formTitle: data?.getFormByIdA?.formTitle || "",
        description: data?.getFormByIdA?.description || "",
        color: data?.getFormByIdA?.formMetadata?.theme?.color || "",
        visibility: data?.getFormByIdA?.formMetadata?.visibility || false,
      });
      setFormTheme({
        color: data?.getFormByIdA?.formMetadata?.theme?.color || "#fff",
        font:
          data?.getFormByIdA?.formMetadata?.theme?.font ||
          availableFonts[1].value,
        image: data?.getFormByIdA?.formMetadata?.theme?.image,
      });
      dispatch(setCurrentForm(data?.getFormByIdA));
    },
    onError: (err) => {
      console.log("CURRENT FORM IS", err);
    },
  });
  const [getResCount, resCount] = useLazyQuery(GET_FORM_RESPONSE_COUNT, {
    variables: { getResCountByIdAId: params?.id },
  });

  useState(() => {
    getResCount();
    getFormById();

    if (formTheme?.image) previewFile();
  }, []);
  useEffect(() => {
    if (!formById?.loading && state.currentForm == null)
      navigate("/dashboard/manage-form");
  }, [state]);

  useEffect(() => {
    !formById?.loading &&
      dispatch(
        updateFormDetails({
          formTitle: formDetails?.formTitle,
          description: formDetails?.description,
          id: state?.currentForm?.id,
          theme: formTheme,
          visibility: formDetails?.visibility,
        })
      );
  }, [formDetails, formTheme]);

  useEffect(() => {
    previewFile();
  }, [formFile]);

  const saveForm = () => {
    setMessage(null);
    updateForm();
  };

  const ShareModal = ({ handleClose }) => {
    const [currentTab, setCurrentTab] = useState(0);
    return (
      <section className='shareModalWrapper flex items-center justify-content-center'>
        <div className='shareModal'>
          <div className='sectionHeaderTitle w-100 flex items-center justify-content-between  p-3'>
            <h5>Share Form</h5>
            <button
              className='btn btn-danger px-4 text-lg'
              onClick={handleClose}
            >
              &times;
            </button>
          </div>

          <div className='TabsWrapper'>
            <span
              className={
                "fw-bold mx-3 cursor-pointer " +
                (currentTab == 0 && "border-bottom border-3 border-primary")
              }
              style={{
                color: currentTab == 0 ? "#007bff" : "#111",
                cursor: "pointer",
              }}
              onClick={() => setCurrentTab(0)}
            >
              Share URL
            </span>
            <span
              className={
                "fw-bold mx-3 cursor-pointer " +
                (currentTab == 1 && "border-bottom border-3 border-primary")
              }
              style={{
                color: currentTab == 1 ? "#007bff" : "#111",
                cursor: "pointer",
              }}
              onClick={() => setCurrentTab(1)}
            >
              QR code
            </span>
          </div>
          <div className='shareContentWrapper w-100'>
            {currentTab === 0 ? (
              <>
                <div
                  className='d-flex flex-col align-items-center justify-content-between p-2'
                  style={{ width: "100%" }}
                >
                  <input
                    className=' d-flex align-items-center m-0 overflow-scroll no-scrollbar px-2 border-2 border-bottom border-primary my-4 w-100 text-center focus:outline-none'
                    value={
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      "/forms/" +
                      EncodeURL(state?.currentForm?._id)
                    }
                    style={{
                      border: "none",
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  <div className='buttonGroup d-flex align-items-center'>
                    <a
                      href={`https://wa.me?text=Hey%2C%0ACan%20you%20please%20fill%20out%20this%20survey%20for%20${
                        state?.currentForm?.surveyorDetails?.fullName || "Me"
                      }%3A%0A${window.location.protocol}//${
                        window.location.host
                      }/forms/${EncodeURL(state?.currentForm?._id)}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='btn  col-xs-4 m-1'
                      style={{
                        backgroundColor: "#128C7E",
                        color: "#fff",
                      }}
                    >
                      Share to &nbsp;
                      <IoLogoWhatsapp />
                    </a>
                    <button
                      className='btn btn-primary col-xs-4 m-1 align-items-center'
                      onClick={() => {
                        if (navigator.clipboard) {
                          navigator.clipboard.writeText(
                            `${window.location.protocol}//${
                              window.location.host
                            }/forms/${EncodeURL(state?.currentForm?._id)}`
                          );
                        } else {
                          window.clipboardData.setData(
                            `${window.location.protocol}//${
                              window.location.host
                            }/forms/${EncodeURL(state?.currentForm?._id)}`
                          );
                        }
                        success("Link copied to clipboard");
                      }}
                    >
                      <IoCopyOutline /> Copy Url
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className='d-flex flex-col w-100 items-center justify-content-between p-4'>
                <div className='qrCode position-relative'>
                  <QRCode
                    id='qr-gen'
                    value={`https://hubsurvey.netlify.app/forms/${EncodeURL(
                      state?.currentForm?._id
                    )}`}
                    size={window.innerWidth < 640 ? 120 : 240}
                    level={"H"}
                    includeMargin={true}
                  />
                </div>
                <div className='buttonGroup d-flex align-items-center'>
                  <button
                    className='btn btn-primary m-1 d-flex items-center'
                    onClick={() => {
                      const canvas = document.getElementById("qr-gen");

                      // Convert canvas to blob
                      const dataURL = canvas.toDataURL("image/png");

                      // Convert dataURL to blob
                      const files = dataURLToFile(dataURL, "image.png");

                      function dataURLToFile(dataurl, filename) {
                        var arr = dataurl.split(","),
                          mime = arr[0].match(/:(.*?);/)[1],
                          bstr = atob(arr[1]),
                          n = bstr.length,
                          u8arr = new Uint8Array(n);

                        while (n--) {
                          u8arr[n] = bstr.charCodeAt(n);
                        }

                        return new File([u8arr], filename, { type: mime });
                      }

                      let shareData = {
                        title: "Survey Form by " + state.currentForm.formTitle,
                        text:
                          "Hey, Would you please fill out this survey form by " +
                          state?.currentForm?.surveyorDetails?.fullName,
                        url: `https://hubsurvey.netlify.app/forms/${EncodeURL(
                          state?.currentForm?._id
                        )}`,
                        files: [files],
                      };
                      if (navigator.share) {
                        navigator
                          .share(shareData)
                          .then(() => success("Form shared successfully"))
                          .catch((e) => err(e.message));
                      } else err("Browser does not support sharing..");
                    }}
                  >
                    Share &nbsp; <IoMdShareAlt />
                  </button>
                  <button
                    className='btn btn-primary m-1 d-flex items-center'
                    onClick={() => {
                      const canvas = document.getElementById("qr-gen");
                      const pngUrl = canvas
                        .toDataURL("image/png")
                        .replace("image/png", "image/octet-stream");
                      let downloadLink = document.createElement("a");
                      downloadLink.href = pngUrl;
                      downloadLink.download = `${formDetails.formTitle} QRCODE.png`;
                      document.body.appendChild(downloadLink);
                      downloadLink.click();
                      document.body.removeChild(downloadLink);
                    }}
                  >
                    Download&nbsp; <HiOutlineDownload />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  };
  return (
    <div style={{ "--formFont": formTheme?.font }}>
      {contextHolder}
      <>
        {shareModalOpen && (
          <ShareModal handleClose={() => setShareModalOpen(false)} />
        )}
        <section
          className={
            "d-flex flex-column position-fixed settingsWrapper no-scrollbar " +
            (settingsOpen && "settingsOpen")
          }
          style={{ overflowY: "scroll" }}
        >
          <div className='settingsTop d-flex items-center justify-content-between relative  px-4 py-2'>
            <span className='text-uppercase fw-bold'>Settings</span>
            <button
              className='btn btn-primary px-4 py-1'
              onClick={() => setSettingsOpen(false)}
            >
              &times;
            </button>
          </div>
          <div className='settingsContent px-4 py-3 my-2'>
            <div className='settingsContentDiv'>
              <h6 className='settingsContentLabel'>Accepting Responses?</h6>
              <div className='settingsContentFeature'>
                <Select
                  // options={availableFonts}

                  value={formDetails?.visibility}
                  onChange={(e) =>
                    setFormDetails({ ...formDetails, visibility: e })
                  }
                >
                  {[
                    { value: "PUBLIC", label: "Yes" },
                    { value: "PRIVATE", label: "No" },
                  ].map((Val, idx) => (
                    <Select.Option key={idx} value={Val.value}>
                      {Val.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
            <Divider />
            <div className='settingsContentDiv'>
              <h6 className='settingsContentLabel'>Text Style</h6>
              <div className='settingsContentFeature'>
                <Select
                  // options={availableFonts}
                  style={{ width: "100%", fontFamily: formTheme?.font }}
                  value={formTheme?.font}
                  onChange={(e) => setFormTheme({ ...formTheme, font: e })}
                >
                  {availableFonts.map((Font, idx) => (
                    <Select.Option
                      style={{ fontFamily: Font.value }}
                      key={idx}
                      value={Font.value}
                    >
                      {Font.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
            <Divider />
            <div className='settingsContentDiv'>
              <h6 className='settingsContentLabel'>Color Styles</h6>
              <div className='settingsContentFeature '>
                <h6 className='settingsContentLabel my-3'>Solid Colors</h6>
                <div className='flex flex-wrap'>
                  {availableColors?.map((color) => (
                    <button
                      className='colorBlob rounded-circle m-1'
                      key={color}
                      style={{
                        background: color,
                        border:
                          "1px solid " + color?.includes("linear-gradient")
                            ? "black"
                            : darkenColor(color),
                      }}
                      onClick={() =>
                        setFormTheme({
                          ...formTheme,
                          color: color,
                        })
                      }
                    ></button>
                  ))}
                </div>
                <h6 className='settingsContentLabel my-3'>Gradients</h6>
                <div className='flex flex-wrap'>
                  {availableGradients?.map((color) => (
                    <button
                      className='colorBlob rounded-circle m-1'
                      key={color}
                      style={{
                        background: color,
                        border:
                          "1px solid " + color?.includes("linear-gradient")
                            ? "black"
                            : darkenColor(color),
                      }}
                      onClick={() =>
                        setFormTheme({
                          ...formTheme,
                          color: color,
                        })
                      }
                    ></button>
                  ))}
                </div>
              </div>
            </div>
            <Divider />
            <h6 className='settingsContentDiv'>
              <div className='settingsContentLabel'>Images</div>
              <p style={{ fontSize: "12px", opacity: "0.5" }}>
                Recommeded height : 250px
              </p>
            </h6>
            <div className='formImageInput position-relative'>
              <Button
                type='primary'
                className='position-absolute top-0 pe-none'
              >
                {formFile || formTheme?.image
                  ? "Image Uploaded"
                  : "Upload Image"}
              </Button>
              <input
                type='file'
                style={{ appearance: "none", opacity: "0" }}
                onChange={(e) => setFormFile(e.target.files[0])}
              />
            </div>
            <Button
              type='primary'
              className='my-3'
              onClick={() => {
                setFormTheme({
                  ...formTheme,
                  image: null,
                });
                setFormTheme({
                  ...formTheme,
                  image: `https://bg.linkb.org/generate/${window.innerWidth}/250`,
                });
              }}
            >
              Random Image
            </Button>{" "}
            <p style={{ fontSize: "12px", opacity: "0.5" }}>
              New Image every 60s
            </p>
            {formTheme?.image && (
              <div className='imagePreview position-relative mt-3 rounded overflow-hidden'>
                <img
                  src={formTheme?.image}
                  alt=''
                  className='w-100 h-auto rounded'
                />
                <div
                  className='overlay position-absolute h-100 w-100 border border-2 border-danger top-0 flex items-center content-center'
                  onClick={() => {
                    setFormFile(null);
                    setFormTheme({ ...formTheme, image: null });
                  }}
                >
                  {" "}
                  <FaTrash color='red' />
                </div>
              </div>
            )}
            <Divider />
            <div className='btn btn-primary w-100' onClick={saveForm}>
              {loading ? <Loader color='#fff' /> : <> Save</>}
            </div>
          </div>
        </section>

        <div className='sectionHeaderWrapper flex items-center content-between singleFormHeader py-0 '>
          {formById?.loading && <Skeleton active={true} />}
          {!formById?.loading &&
          localStorage.getItem("shub-roles") !== roles.SURVEYOR ? (
            <>
              <div className='sectionHeaderTitle flex-col col-xs-12 col-lg-4'>
                <input
                  type='text'
                  value={formDetails?.formTitle}
                  placeholder='Enter form title'
                  className=' px-2 border-0 border-2 border-dark border-bottom'
                  id='formTitle'
                  onChange={(e) =>
                    setFormDetails({
                      ...formDetails,
                      formTitle: e.target.value,
                    })
                  }
                  style={{ fontFamily: formTheme?.font, width: "100%" }}
                />

                <TextArea
                  rows={2}
                  type='text'
                  className='formDesc px-2 border-0 border-2 border-dark border-bottom'
                  placeholder='Enter form description'
                  value={formDetails?.description}
                  id='formDescription'
                  onChange={(e) =>
                    setFormDetails({
                      ...formDetails,
                      description: e.target.value,
                    })
                  }
                  style={{ fontFamily: formTheme?.font, width: "100%" }}
                />
              </div>
            </>
          ) : (
            <div className='sectionHeaderTitle flex-col col-md-4'>
              <h2 className='formTitle'>{formDetails?.formTitle}</h2>
              <p style={{ fontWeight: 400 }}>{formDetails?.description}</p>
            </div>
          )}

          <div className='titleRight col-md-4'>
            <Popover content='Share Form' placement='bottom'>
              <button
                className='position-relative mx-3'
                style={{ background: "transparent", border: "none" }}
                onClick={() => setShareModalOpen(true)}
              >
                <label>
                  <HiShare
                    style={{
                      fontSize: "25px",
                    }}
                  />
                </label>
              </button>
            </Popover>
            <Popover content='Preview Form' placement='bottom'>
              <Link
                style={{ color: "#111" }}
                to={"/forms/" + EncodeURL(state?.currentForm?._id)}
                target='_blank'
                className='position-relative mx-3'
              >
                <label>
                  <AiOutlineEye
                    style={{
                      fontSize: "25px",
                    }}
                  />
                </label>
              </Link>
            </Popover>
            {localStorage.getItem("shub-roles") !== roles.SURVEYOR && (
              <>
                <div className='position-relative mx-3'>
                  <Popover content='Settings' placement='bottom'>
                    <label onClick={() => setSettingsOpen(true)}>
                      <IoSettingsOutline
                        style={{
                          rotate: settingsOpen ? "45deg" : "0deg",
                          transition: "0.2s ease",
                          fontSize: "25px",
                        }}
                      />
                    </label>
                  </Popover>
                </div>
                <div className='btn btn-primary' onClick={saveForm}>
                  {loading ? <Loader color='#fff' /> : <> Save</>}
                </div>
              </>
            )}
          </div>
        </div>

        <div className='TabsWrapper'>
          {localStorage.getItem("shub-roles") !== roles.SURVEYOR && (
            <NavLink to='questions'>Questions</NavLink>
          )}
          <NavLink to='responses'>
            Responses{" "}
            <span
              className='badge badge-dark'
              style={{ background: "#151515" }}
            >
              {resCount?.loading ? (
                <Loader color='#fff' />
              ) : (
                resCount.data?.getResCountByIdA
              )}
            </span>
          </NavLink>
          <NavLink to='summary'>Summary</NavLink>
          {/* <NavLink to='analytics'>Analytics</NavLink> */}
        </div>
        <div
          className='formsDetailsWrapper'
          style={{
            background: window.location.pathname.includes("questions")
              ? formTheme?.color
              : "#b0d6ff",
            "--formFont": formTheme?.font,
            borderRadius: "10px",
          }}
        >
          {formById?.loading ? <Loader /> : <Outlet />}
          {/* {JSON.stringify(form?.questions)} */}
        </div>
      </>
    </div>
  );
};

export default SingleForm;
